import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'

export type GtmCheckoutPurchaseFrontendValidationErrorType = {
  error_name: string
}

export const gtmCheckoutPurchaseFrontendValidationError = ({
  error_name,
}: GtmGlobalStoreProps & GtmCheckoutPurchaseFrontendValidationErrorType) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_checkout_purchase_validation_error',
    event_id: uuid,
    error_name,
  })
}
